import { AppBar, Box, IconButton, Typography, styled } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import DepedLogo from "../../../assets/images/deped_logo.png";

const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open, width }) => ({
  background: "#f0f0f0",
  // boxShadow: "none",
  // background: "linear-gradient(40deg, #15144e, #232288, #3431c8)",
  // "linear-gradient(40deg, #383838, #505050, rgba(105, 105, 105, 0.9))",
  // "linear-gradient(90deg, rgba(66, 201, 116, 1), rgba(59, 152, 184, 1), rgba(26, 214, 164, 1))",
  // "#309154",
  // zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: "58px",
  width: `calc(100% - ${theme.spacing(7)} - 1px)`,
  ...(open && {
    marginLeft: `calc(${theme.spacing(7)} + 1px)`,
    width: `calc(100% - ${width}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
  "@media (max-width: 380px)": {
    width: "100%",
  },
}));

function Topbar({
  themeProp,
  drawerWidth,
  drawerOpenStatus,
  openDrawerFunction,
  closeDrawerFunction,
}) {
  return (
    <StyledAppBar
      position="fixed"
      theme={themeProp}
      open={drawerOpenStatus}
      width={drawerWidth}
    >
      <Box sx={{ display: "flex", alignItems: "center", py: 1, px: 2 }}>
        <IconButton
          color="inherit"
          aria-label="open drawer"
          onClick={drawerOpenStatus ? closeDrawerFunction : openDrawerFunction}
          edge="start"
          sx={{
            display: "none",
            color: "#59395c",
            mr: 5,
            ...(drawerOpenStatus && { display: "none" }),
            "@media (max-width: 380px)": {
              display: "flex",
            },
            "@media (max-width: 480px)": {
              mr: 2,
            },
          }}
        >
          <MenuIcon sx={{ fontSize: "25px" }} />
        </IconButton>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box
            component="img"
            variant="img"
            src={DepedLogo}
            sx={{
              mr: 2,
              height: "50px",
              width: "50px",
              "@media (min-height: 1920px)": {
                width: "100px",
              },
            }}
          />
          <Box
            sx={{
              "@media (max-width: 820px)": {
                display: "none",
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Poppins",
                fontSize: "20px",
                fontWeight: "bold",
                color: "black",
                textWrap: "wrap",
                letterSpacing: "2px",
                wordSpacing: "2px",
              }}
            >
              Learning Outcomes Assessment Data GAthering Tool
            </Typography>
          </Box>
          <Box
            sx={{
              display: "none",
              "@media (max-width: 820px)": {
                display: "flex",
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Poppins",
                fontSize: "20px",
                fontWeight: "bold",
                color: "black",
                textWrap: "wrap",
              }}
            >
              LOADGAT
            </Typography>
          </Box>
        </Box>
      </Box>
    </StyledAppBar>
  );
}

export default Topbar;
